import React from 'react';
import { ResponsiveTableContent, ResponsiveTableContentProps } from 'components/molecules/ResponsiveTableContent';
import { ResponsiveTablePagination, ResponsiveTablePaginationProps } from 'components/molecules/ResponsiveTablePagination/ResponsiveTablePagination';


export type ServerResponsiveTableProps<T> = ResponsiveTableContentProps<T> & ResponsiveTablePaginationProps;

export default function ServerResponsiveTable<T>(props: ServerResponsiveTableProps<T>) {
    return (
        <section className="table site">
            <ResponsiveTableContent
                boldRowIf={props.boldRowIf}
                data={props.data}
                fields={props.fields}
                sortBy={props.sortBy}
                sortDirection={props.sortDirection}
                onClickSort={props.onClickSort}
                tableSize={props.pageSize}
                loading={props.loading}
            />
            <ResponsiveTablePagination
                loading={props.loading}
                currentPageNumber={props.currentPageNumber}
                onChangePage={props.onChangePage}
                tableSize={props.tableSize}
                pageSize={props.pageSize}
                paginationDisplayMaxPages={props.paginationDisplayMaxPages}
            />
        </section>
    );
}